import React, { useEffect, useState } from 'react';
import './App.css';
import { stackApp } from './stackApp';
import { Game } from './Game';

function AppWithAuth() {
  const { useStackApp } = require('@stackframe/react');
  const app = useStackApp();
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('code') && params.has('state')) {
      app.callOAuthCallback()
        .catch(err => console.warn('[auth] OAuth callback error:', err))
        .finally(() => setAuthReady(true));
    } else {
      setAuthReady(true);
    }
  }, [app]);

  if (!authReady) return null;
  return <Game />;
}

function App() {
  if (stackApp) return <AppWithAuth />;
  return <Game />;
}

export default App;
